import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const AmbassadorItemContent = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutral[200]}`,
  borderTop: 'none',
  flex: 1,
}));
